import { CandidateRegistrationDtoClient } from "@/api/candidate/dto/candidate-registration.dto";
import { PayementStatus } from "@/api/enums/PayementStatus";
import { Badge } from "@/components/atoms/Badge";
import GreenCheck from "@/components/atoms/GreenCheck";
import { PayementUtil } from "@/lib/payement-util";
import { Hourglass } from "lucide-react";

interface PayementBadgeProps {
  registration: CandidateRegistrationDtoClient;
}

const PayementBadge = ({ registration }: PayementBadgeProps) => {
  if (PayementUtil.isPaid(registration.payementStatus)) return <GreenCheck />;
  else if (
    registration.payementStatus ===
    PayementStatus.PERSONAL_WAITING_FOR_VALIDATION
  )
    return (
      <div className="flex flex-row gap-2">
        <Badge variant="sky">Virement</Badge>{" "}
        <Hourglass className="w-6 h-6 text-orange-500 bg-orange-100 p-1 rounded-full stroke-2" />
      </div>
    );
  else return <Badge variant="red">En attente</Badge>;
};

export default PayementBadge;
